module.exports = __webpack_public_path__ + "src/assets/textures/petri/blue_petri_lambert1_AO.jpg";